export default __webpack_public_path__ + "static/media/md-card-bg-Kubernetes.be4657b6.png";